import validate from "/home/vsts/work/1/s/zenapptic-website-nuxt/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/vsts/work/1/s/zenapptic-website-nuxt/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}